<div style="position: relative" (window:resize)="onResize($event)" [ngClass]="{ 'dooh-map': isDOOH }">
	<app-loader [showLoader]="showLoad"></app-loader>
	<!-- Map -->
	<div>
		<div>
			<div class="map-wrapper">
				<div id="map"></div>
				<div id="geofence-disclaimer" class="geofence-disclaimer">
					<div class="geofence-disclaimer-section">
						<img class="geofence-disclaimer-img" src="../../../../../../assets/images/info-circle.png" />
						<span class="geofence-disclaimer-text"
							>Geofence/geo recency points may not display due to category-specific privacy restrictions in a selected
							campaign.</span
						>
					</div>
				</div>
			</div>
			<!-- region details -->
			<div class="map-region-container">
				<div class="minimap-container">
					<div class="minimap" id="minimap" style="height: 100%"></div>
				</div>

				<div class="geofence-legend" *ngIf="showGeofenceLegends">
					<div class="geocenter">
						<div class="geofence-dot"></div>
						<div class="geo-values">Geofence</div>
					</div>
					<div class="geocenter">
						<div class="retargeting-dot"></div>
						<div class="geo-values">Geo Recency</div>
					</div>
				</div>

				<div class="polygon-details" *ngIf="!showGeofenceCenterDetailsFlag">
					<div class="map-region-lift" *ngIf="polygonLayerDetails.showLift">
						{{ polygonLayerDetails.avgLift ? polygonLayerDetails.avgLift + 'x' : '--' }} Lift
					</div>
					<div class="item">
						<span class="heading">postal code: </span>
						<span class="value">{{ polygonLayerDetails.zip ? polygonLayerDetails.zip : '--' }}</span>
					</div>
					<div class="item">
						<span class="heading">population: </span>
						<span class="value">{{ polygonLayerDetails.population ? polygonLayerDetails.population : '--' }}</span>
					</div>
					<div class="lift-details">
						<!-- Show Average Home Value -->
						<div class="item">
							<span class="heading">avg home value: </span>
							<span class="value">{{
								polygonLayerDetails.avgHomeValue ? '$' + (polygonLayerDetails.avgHomeValue | formatNumber) : '--'
							}}</span>
						</div>
						<!-- Show Average Median Age -->
						<div class="item">
							<span class="heading">median age: </span>
							<span class="value">{{
								polygonLayerDetails.avgMedianAge ? polygonLayerDetails.avgMedianAge : '--'
							}}</span>
						</div>
						<!-- Show Average Income -->
						<div class="item">
							<span class="heading">avg income: </span>
							<span class="value">{{
								polygonLayerDetails.avgIncome ? '$' + (polygonLayerDetails.avgIncome | formatNumber) : '--'
							}}</span>
						</div>
					</div>
				</div>

				<!-- Geo fence/georecency details-->
				<div class="geofence-pin-details" *ngIf="showGeofenceCenterDetailsFlag">
					<div class="location">{{ geofenceCenterDetails ? geofenceCenterDetails.name : '' }}</div>
					<div class="impressions">
						<div>{{ geofenceCenterDetails ? (geofenceCenterDetails.total_impression_sum | number) : 0 }}</div>
						<div>impressions</div>
					</div>
					<div class="other-metrics">
						<div class="clicks">
							<div>{{ geofenceCenterDetails ? (geofenceCenterDetails.total_click_sum | number) : 0 }}</div>
							<div>clicks</div>
						</div>
						<div class="ctr">
							<div>{{ geofenceCenterDetails ? geofenceCenterDetails.click_through_rate + '%' : '0.00%' }}</div>
							<div>ctr</div>
						</div>
					</div>

					<div *ngIf="geofenceCenterDetails" class="mobile-metrics">
						<div class="ios">
							<svg
								width="19px"
								height="22px"
								viewBox="0 0 19 22"
								version="1.1"
								xmlns="http://www.w3.org/2000/svg"
								xmlns:xlink="http://www.w3.org/1999/xlink"
							>
								<g
									id="1280-GeoFence"
									stroke="none"
									stroke-width="1"
									fill="none"
									fill-rule="evenodd"
									stroke-linejoin="round"
								>
									<g
										id="Geofence/Geography"
										transform="translate(-123.000000, -597.000000)"
										class="color"
										stroke="#9868E2"
									>
										<g id="Organism/Map/Table-Collapsed/Geo" transform="translate(100.000000, 123.000000)">
											<g id="Organism/Map/Legend/Device" transform="translate(10.000000, 345.000000)">
												<g id="Group-5">
													<g id="Atom/Icon/Device/Apple" transform="translate(13.000000, 129.000000)">
														<path
															d="M16.4432999,8.89264889 C12.8247496,11.2607312 13.9381497,14.7432051 17,16.1361947 C15.8865999,17.9470812 13.9381497,20.8723593 12.8247496,20.8723593 C11.7113495,20.8723593 11.0154744,20.0365656 9.76289932,20.0365656 C8.51032421,20.0365656 7.58164686,21.4182323 6.42269901,20.8723593 C4.05672379,19.7579677 2.45915883,16.0521368 2.10827361,13.9074114 C1.4515044,9.89302287 3.91754878,7.49965931 5.86599896,7.22106139 C7.0743637,7.04828412 8.28054714,7.41974801 9.4845493,8.33545306 C12.1752662,6.38526764 14.4948498,6.57099958 16.4432999,8.89264889 Z M11.9913838,1 C12.1042295,3.68817204 11.1086224,5.35483871 9.00456251,6 C8.92363713,3.41935484 9.91924424,1.75268817 11.9913838,1 Z"
															id="Combined-Shape"
														></path>
													</g>
												</g>
											</g>
										</g>
									</g>
								</g>
							</svg>
							<span>{{ geofenceCenterDetails ? (geofenceCenterDetails.total_ios | number : '1.2-2') : '0.00' }}%</span>
						</div>
						<div
							class="progress"
							[ngStyle]="{
								'background-image':
									'linear-gradient(to right, var(--primary-color)' +
									geofenceCenterDetails.total_ios +
									'%, var(--secondary-color))'
							}"
						>
							<div class="circle" [ngStyle]="{ left: geofenceCenterDetails.total_ios + '%' }"></div>
						</div>
						<div class="android">
							<svg
								width="19px"
								height="22px"
								viewBox="0 0 19 22"
								version="1.1"
								xmlns="http://www.w3.org/2000/svg"
								xmlns:xlink="http://www.w3.org/1999/xlink"
							>
								<g id="1280-GeoFence" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
									<g
										id="Geofence/Geography"
										transform="translate(-286.000000, -597.000000)"
										class="color"
										fill="#5BC0EB"
										fill-rule="nonzero"
									>
										<g id="Organism/Map/Table-Collapsed/Geo" transform="translate(100.000000, 123.000000)">
											<g id="Organism/Map/Legend/Device" transform="translate(10.000000, 345.000000)">
												<g id="Group-5">
													<g id="Atom/Icon/Device/Android" transform="translate(176.000000, 129.000000)">
														<path
															d="M17.5,13.5 L17.5,14 C17.5,17.883159 13.903645,21 9.5,21 C5.09635498,21 1.5,17.883159 1.5,14 L1.5,14 L1.5,13.5 L17.5,13.5 Z M16.475,14.5 L2.526,14.5 L2.53914886,14.6368226 C2.90148562,17.5678818 5.73607609,19.8897788 9.24801919,19.9961888 L9.24801919,19.9961888 L9.5,20 C13.1275419,20 16.0898873,17.637669 16.4608511,14.6368226 L16.4608511,14.6368226 L16.475,14.5 Z M15.6464466,4.23223305 C16.232233,3.64644661 17.1819805,3.64644661 17.767767,4.23223305 C18.3535534,4.81801948 18.3535534,5.76776695 17.767767,6.35355339 L17.767767,6.35355339 L16.3535534,7.76776695 C16.1795812,7.94173911 15.9735068,8.06404344 15.7543981,8.13467995 C16.8460863,9.32768961 17.5,10.8441762 17.5,12.5 L17.5,12.5 L17.5,13 L1.5,13 L1.5,12.5 C1.5,10.8441762 2.15391369,9.32768961 3.24549638,8.13278332 C3.02602071,8.06376293 2.82021931,7.94153965 2.64644661,7.76776695 L1.23223305,6.35355339 C0.646446609,5.76776695 0.646446609,4.81801948 1.23223305,4.23223305 C1.81801948,3.64644661 2.76776695,3.64644661 3.35355339,4.23223305 L4.76776695,5.64644661 C5.03218444,5.9108641 5.17724681,6.24943935 5.20295407,6.59522438 C6.44518922,5.90089636 7.92067672,5.5 9.5,5.5 C11.0797486,5.5 12.5556055,5.90111233 13.7988093,6.59482156 C13.8227532,6.24943935 13.9678156,5.9108641 14.232233,5.64644661 L14.232233,5.64644661 Z M9.5,6.5 C5.87245809,6.5 2.91011268,8.86233105 2.53914886,11.8631774 L2.53914886,11.8631774 L2.525,12 L16.474,12 L16.4608511,11.8631774 C16.0985144,8.93211817 13.2639239,6.61022119 9.75198081,6.5038112 L9.75198081,6.5038112 Z M7,9 C7.55228475,9 8,9.44771525 8,10 C8,10.5522847 7.55228475,11 7,11 C6.44771525,11 6,10.5522847 6,10 C6,9.44771525 6.44771525,9 7,9 Z M12,9 C12.5522847,9 13,9.44771525 13,10 C13,10.5522847 12.5522847,11 12,11 C11.4477153,11 11,10.5522847 11,10 C11,9.44771525 11.4477153,9 12,9 Z M17.0606602,4.93933983 C16.865398,4.74407768 16.5488155,4.74407768 16.3535534,4.93933983 L16.3535534,4.93933983 L14.9393398,6.35355339 C14.7440777,6.54881554 14.7440777,6.86539803 14.9393398,7.06066017 C15.134602,7.25592232 15.4511845,7.25592232 15.6464466,7.06066017 L15.6464466,7.06066017 L17.0606602,5.64644661 C17.2559223,5.45118446 17.2559223,5.13460197 17.0606602,4.93933983 Z M1.93933983,4.93933983 C1.74407768,5.13460197 1.74407768,5.45118446 1.93933983,5.64644661 L3.35355339,7.06066017 C3.54881554,7.25592232 3.86539803,7.25592232 4.06066017,7.06066017 C4.25592232,6.86539803 4.25592232,6.54881554 4.06066017,6.35355339 L2.64644661,4.93933983 C2.45118446,4.74407768 2.13460197,4.74407768 1.93933983,4.93933983 Z"
															id="Combined-Shape"
														></path>
													</g>
												</g>
											</g>
										</g>
									</g>
								</g>
							</svg>
							<span
								>{{ geofenceCenterDetails ? (geofenceCenterDetails.total_android | number : '1.2-2') : '0.00' }}%</span
							>
						</div>
					</div>
				</div>

				<div
					class="impression-gradient flex-row flex-wrap align-content-center justify-content-center align-items-center"
				>
					<label>Impressions</label>
					<div class="gradient">
						<div class="less">less</div>
						<div class="item" [ngStyle]="{ opacity: x }" *ngFor="let x of [0.3, 0.4, 0.5, 0.6, 0.7]"></div>
						<div class="more">more</div>
					</div>
				</div>
			</div>
		</div>
		<div class="map-region-container dooh" *ngIf="isDOOH">
			<div class="header_controllers">
				<div class="selected-count">{{ doohGeoRecencyData?.features?.length }} Selected</div>
				<div class="action-links">
					<a
						href="javascript:void(0);"
						(click)="selectAll()"
						[class.disabled]="doohGeoRecencyData?.features?.length === doohData?.features?.length"
						>select all</a
					>
					<a
						href="javascript:void(0);"
						(click)="clearAll()"
						[class.disabled]="doohGeoRecencyData?.features?.length === 0"
						>clear all</a
					>
				</div>
			</div>
			<div *ngFor="let feature of doohData?.features; trackBy: trackByRegionId" class="map-region-details">
				<div class="map-region-detail-container">
					<input
						type="checkbox"
						[id]="feature.properties.id"
						[(ngModel)]="selectedItems[feature.properties.id]"
						(change)="onCheckboxChange($event, feature)"
						class="styled-checkbox"
					/>
					<span class="checkmark"></span>
					<label [for]="feature.properties.id">
						<span class="dot" [ngStyle]="{ 'background-color': feature.properties.venue_color }"></span>
						<span class="venue_name">{{ feature.properties.venue_type_1 }}</span>
					</label>
				</div>
			</div>
		</div>
		<div class="zoom-options-container">
			<div class="zoom-icon" (click)="zoomIn()">
				<img src="../../../../../assets/images/zoom_in.png" alt="zoom in icon" />
			</div>
			<div class="zoom-icon" (click)="zoomOut()">
				<img src="../../../../../assets/images/zoom_out.png" alt="zoom out icon" />
			</div>
		</div>

		<div class="no-data-container" *ngIf="noData">
			<div class="map-no-data">No Data Available</div>
		</div>
	</div>
	<!-- geography Table -->
	<div
		class="geography-table {{ sectionclass }}"
		*ngIf="tertiarykey"
		[ngClass]="{ 'table-active': showTable && !noData }"
	>
		<h2 class="title" (click)="toggleTable()">
			Geography
			<span class="table-dropdownicon"><i class="fa {{ tableIcon }}"></i></span>
		</h2>
		<div class="table" [ngClass]="{ 'no-data': noData }">
			<app-datatable-r10
				(selected)="onPlaceSelected($event)"
				key="{{ tertiarykey }}"
				datatableconfig="{{ datatableconfig }}"
				columnsconfig="{{ columnsconfig }}"
				[showtable]="showTable"
				uniqueoverwriteid=" {{ uniqueoverwriteid }}_{{ path }}"
				iscustomendpoint="{{ iscustomendpoint }}"
			></app-datatable-r10>
		</div>
	</div>
</div>
